
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b070748c&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ParentProductChangeConfig.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ParentProductChangeConfig.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-b070748c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ParentProductChangeConfig.vue"),
  /* scopeId */
  "data-v-b070748c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/settings/ParentProductChangeConfig.vue
// module id = 703
// module chunks = 2